import { useListClinics } from '@pa/api/admin'
import { HealthOverview, parseHealthOverviewSearch, viewerTimeZone, type HealthOverviewSearch } from '@pa/staff'
import { createFileRoute, Link } from '@tanstack/react-router'

/**
 * S-07 Health, all clinics (UserFlows S-07; Frontend §7.1, §7.2): the shared `health` feature's `HealthOverview` over
 * #59 and #60, with `attention`, `q`, `clinic` (incident filter, options from #38) and `page` in the URL. Row click
 * → the clinic's S-04 Health tab. Cross-clinic times in the viewer's zone (API.md §1.4).
 */
export const Route = createFileRoute('/_authed/health')({
  validateSearch: (raw: Record<string, unknown>): HealthOverviewSearch => parseHealthOverviewSearch(raw),
  component: function HealthRoute() {
    const search = Route.useSearch()
    const navigate = Route.useNavigate()
    const clinics = useListClinics({ pageSize: '100' }, { query: { staleTime: 60_000 } })
    return (
      <HealthOverview
        search={search}
        onSearch={(next, opts) => {
          void navigate({ search: next, replace: opts?.replace ?? false })
        }}
        clinics={clinics.data?.items.map((c) => ({ id: c.id, name: c.name }))}
        timeZone={viewerTimeZone()}
        onOpenClinic={(clinicId) => {
          void navigate({ to: '/clinics/$clinicId/$tab', params: { clinicId, tab: 'health' } })
        }}
        renderClinicLink={(clinic) => (
          <Link
            to="/clinics/$clinicId/$tab"
            params={{ clinicId: clinic.id, tab: 'health' }}
            onClick={(e) => {
              e.stopPropagation()
            }}
          >
            <b>{clinic.name}</b>
          </Link>
        )}
      />
    )
  },
})
